import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { BRAND } from './agencyChartTheme';

export type IInsightsLens = 'focus' | 'value';

const LENSES: { value: IInsightsLens; label: string }[] = [
    { value: 'focus', label: 'Dashboard' },
    { value: 'value', label: 'Trends' }
];

const useStyles = createUseStyles({
    tabs: {
        display: 'inline-flex',
        padding: 3,
        borderRadius: 9,
        background: BRAND.tealWash,
        border: `1px solid ${BRAND.tealEdge}`
    },

    tab: {
        border: 0,
        borderRadius: 7,
        padding: '7px 17px',
        font: 'inherit',
        fontSize: 13.5,
        color: BRAND.deepTeal,
        background: 'none',
        cursor: 'pointer'
    },

    tabOn: {
        background: 'linear-gradient(180deg, var(--ion-color-primary) 0%, var(--ion-color-primary-shade) 100%)',
        color: '#fff',
        fontWeight: 500
    }
});

/** The two readers of one digest. */
export const InsightsLensSwitch: FC<{
    lens: IInsightsLens;
    onChange: (lens: IInsightsLens) => void;
}> = ({ lens, onChange }) => {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.tabs} role="tablist" aria-label="Insights lens">
                {LENSES.map(({ value, label }) => (
                    <button
                        key={value}
                        type="button"
                        role="tab"
                        aria-selected={lens === value}
                        data-id={`insights-lens-${value}`}
                        className={`${classes.tab} ${lens === value ? classes.tabOn : ''}`}
                        onClick={() => onChange(value)}
                    >
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
};
